export interface ErrorState {
  error: ErrorNotification | undefined;
  lastId: number;
}

export interface ErrorNotification {
  id: number;
  type: ErrorType;
  name: string;
  message: string;
  level?: ErrorLevel
  showButton?: boolean;
  showDismiss?: boolean;
}

export enum ErrorType {
  MediaError,
  ConnectionError,
  DisconnectionError,
  IncompatibleUserAgent,
  WebViewError
}

export enum ErrorLevel {
  Info,
  Warning,
  Danger
}

export type AddErrorNotificationPayload = Omit<ErrorNotification, "id">;
